import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/toast/toast-container.component';
import { ModalScrollLockService } from './core/services/modal-scroll-lock.service';
import { AuthService } from './core/services/auth.service';
import { SessionExpiryModalComponent } from './shared/session-expiry-modal/session-expiry-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, SessionExpiryModalComponent],
  template: `
    <router-outlet />
    <app-toast-container />
    <app-session-expiry-modal />
  `,
})
export class AppComponent {
  title = 'SjFrontend';

  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      inject(ModalScrollLockService).init();
      const authService = inject(AuthService);
      if (authService.isLoggedIn()) {
        authService.startSessionExpiryWatch();
      } else if (authService.getToken()) {
        authService.handleSessionExpired();
      }
    }
  }
}
